import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';
import H4 from '@bitcoin-portal/bitcoincom-pkg-components/dist/H4';
import Paragraph from '@bitcoin-portal/bitcoincom-pkg-components/dist/Paragraph';
import { StyledContentBlock, ImageWrapper, StyledImage } from './styled';

const Markets = () => {
  const { messages } = useIntl();
  const imgPath = messages['wallet.markets.image'].replace('-sm.png', '');

  return (
    <Section>
      <StyledContentBlock
        flip="both"
        style={{ alignItems: 'center' }}
        aside={
          <ImageWrapper>
            <StyledImage
              maxWidth="unset"
              maxHeight="unset"
              src={messages['wallet.markets.image']}
              alt="Markets"
              sizes="(max-width: 767px) 231w, (max-width: 1199px) 323w, (min-width: 1200px) 584w"
              srcSet={`${imgPath}-sm.png 231w, ${imgPath}-md.png 323w, ${imgPath}-sm@2x.png 632w, ${imgPath}-lg.png 584w, ${imgPath}-md@2x.png 646w, ${imgPath}-lg@2x.png 1168w`}
            />
          </ImageWrapper>
        }
      >
        <div>
          <H4>
            <FormattedMessage id="wallet.markets.title" />
          </H4>
          <Paragraph>
            <FormattedMessage id="wallet.markets.paragraph" />
          </Paragraph>
        </div>
      </StyledContentBlock>
    </Section>
  );
};

export default Markets;
